import PropTypes from 'prop-types';
import React from 'react';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { siteMapPropType } from '@bingads-webui-react/with-site-map';
import { storeQueries, useDataSourceInitializer } from '@bingads-webui-campaign-react/merchant-shared';
import { ReactObservablePromise } from '@bingads-webui-react/react-observable-promise';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { filterMapItem } from './processor-helpers';

const dynamicTabIds = ['mmc-products', 'mmc-store-summary-diagnostics'];

const getSupportedDynamicTabs = (storeBootstrapData) => {
  const supportedDynamicTabs = [];
  if (storeBootstrapData.StoreBootstrapData.ShowProductExplorer) {
    supportedDynamicTabs.push('mmc-products');
  }
  if (storeBootstrapData.StoreBootstrapData.ShowCapiDiag) {
    supportedDynamicTabs.push('mmc-store-summary-diagnostics');
  }
  return supportedDynamicTabs;
};

const defaultBootstrapData = {
  StoreBootstrapData: {
    ShowProductExplorer: false,
    ShowCapiDiag: false,
  },
};

const getFilteredSiteMap = (items, supportedIds = []) => {
  const filter = item => supportedIds.includes(item.id) || !dynamicTabIds.includes(item.id);
  return filterMapItem(items, filter);
};

export function processMMCMenu(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const { scope, serverContext, permissions } = props;
    const {
      values: {
        storeId,
      },
    } = scope;

    useDataSourceInitializer({ scope, serverContext });

    const proccssor = (storeBootstrapData) => {
      const supportedIds = getSupportedDynamicTabs(storeBootstrapData);
      const filteredSiteMap = getFilteredSiteMap(siteMap, supportedIds);
      return <Component {...props} siteMap={filteredSiteMap} />;
    };

    if (!permissions.dynamic.MMCDynamicTab || !storeId) {
      return proccssor(defaultBootstrapData);
    }

    return (
      <ReactObservablePromise
        promise={() => storeQueries.getNewProviderBootstrapData(storeId)}
        promiseHashFn={() => `storeQueries.getNewProviderBootstrapData(${storeId})`}
        fallback={proccssor(defaultBootstrapData)}
        onError={() => proccssor(defaultBootstrapData)}
      >
        {storeBootstrapData => proccssor(storeBootstrapData)}
      </ReactObservablePromise>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    scope: PropTypes.instanceOf(QueryParam).isRequired,
    permissions: PropTypes.shape({
      dynamic: PropTypes.shape({
        MMCDynamicTab: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
    serverContext: PropTypes.shape({
      ServicesEndpoints: PropTypes.shape({
        MmcAPI: PropTypes.string.isRequired,
      }).isRequired,
      CurrentAccount: PropTypes.shape({
        AdvertiserCustomerID: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };

  return withServerContext(withPermissions(withScope(Wrapper)));
}
